import "react-app-polyfill/stable"
import "core-js"
import React from "react"
import ReactDOM from "react-dom"
import { createTheme, ThemeProvider, responsiveFontSizes } from "@mui/material/styles"

import App from "./App"
import "./i18n" // initialise i18next (English + Bahasa Melayu) before rendering
import reportWebVitals from "./reportWebVitals"
import { Provider } from "react-redux"
import { persistStore } from "redux-persist";
import { PersistGate } from "redux-persist/integration/react"
import store from "./store"

const persistor = persistStore(store);

let theme = createTheme({
    typography: {
        fontFamily: ["Jost", "sans-serif"].join(","),
    },
    palette: {
        primary: {
            main: "#232323", //009c99
        },
        secondary: {
            main: "#ffcc80",
        },
        white: {
            main: "#ffffff",
            overrides: {
                MuiButton: {
                    label: {
                        color: "#1C60DD",
                    },
                },
            },
        },
    },
})

theme = responsiveFontSizes(theme);

ReactDOM.render(
    <Provider store={store}>
        <PersistGate loading={null} persistor={persistor}>
            <ThemeProvider theme={theme}>
                <App />
            </ThemeProvider>
        </PersistGate>
    </Provider>,
    document.getElementById("root"),
)

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals()

// Makes airtagcode.com installable on Android ("Add to Home screen" with the Airtag
// logo). public/sw.js caches nothing. Production only, so local development never
// runs a worker.
if (process.env.NODE_ENV === "production" && "serviceWorker" in navigator) {
    window.addEventListener("load", () => {
        navigator.serviceWorker.register(`${process.env.PUBLIC_URL}/sw.js`).catch(() => {})
    })
}

// Chrome fires this when the site can be installed. Kept so the "Add Airtag to your
// home screen" prompt can trigger the real install dialog later.
window.addEventListener("beforeinstallprompt", (event) => {
    event.preventDefault()
    window.__airtagInstallPrompt = event
    window.dispatchEvent(new Event("airtag-installable"))
})
